import React from 'react'
import styles from '../styles'

const PartnerSlide = ({logo, name, description}) => {
  return (
    <div className={`w-full md:h-full h-[50vh] relative flex flex-col flex-1 items-center justify-start mx-2`}>
        <img 
          src={logo} 
          alt="Partner Logo" 
          className='w-full h-full object-cover'
        />
        <div className='absolute flex flex-1 flex-col items-start justify-end p-2 md:px-[30px] bg-primary bg-opacity-30 h-full w-full'>
          <h1 className={`${styles.heading2}`}>{name}</h1>
          <p className={`md:w-[475px] w-[375px] bg-primary bg-opacity-10 p-3  ${styles.paragraph}`}>
            {description}
          </p>
          <div className='flex flex-row gap-x-5 items-center justify-center mt-5 text-white p-3'>
            <a href="#register" className='bg-green-600 text-bold px-4 p-2 border-2 border-white'>Learn more</a>
          </div>
        </div>
        
      </div>
  )
}

export default PartnerSlide
